/* eslint-disable array-callback-return */
import { all, call, put } from 'redux-saga/effects';
import appConfig from 'src/appConfig';
import { successUploadFile, failureUploadFile, setUploadProgress, setUploadDone } from 'src/redux/fileRedux/actions';
import { Toastify } from 'src/services';
import { getFileType, getUploadErrorMessage } from 'src/utils/fileUtils';

import { APIHandler } from '../commonHandlers';
function* uploadFiles(api, action) {
  try {
    const responses = yield all(action.files.map(file => call(uploadSingleFile, api, file)));
    if (responses.length === action.files.length) {
      yield put(setUploadDone(true));
    }
  } catch (error) {
    console.log('UPLOAD_FILES_SAGA', error);
  }
}

function* uploadSingleFile(api, file) {
  try {
    var uploadUrl = '';
    var preUpload = '';

    switch (file.type) {
      case 'exhibit':
        uploadUrl = api.getMultiPartExhibitUploadUrl;
        preUpload = api.preExhibitUpload;
        break;
      case 'final':
        uploadUrl = api.getMultiPartFinalUploadUrl;
        preUpload = api.preFinalUpload;
        break;
      case 'production':
        uploadUrl = api.getMultiPartProductionUploadUrl;
        preUpload = api.preProductionUpload;
        break;
      default:
        break;
    }

    const FILE_CHUNK_SIZE = appConfig.FILE_CHUNK_SIZE;

    const NUM_CHUNKS = Math.floor(file.file.size / FILE_CHUNK_SIZE) + 1;
    file.partNumber = NUM_CHUNKS;
    file.contentType = getFileType(file.file);

    const response = yield call(uploadUrl, file);
    if (response.status === 200) {
      const {
        data: { urls, uploadId },
      } = response;

      let start, end, blob;
      const uploadParts = [];
      const etags = [];
      for (let index = 1; index <= NUM_CHUNKS; index++) {
        start = (index - 1) * FILE_CHUNK_SIZE;
        end = index * FILE_CHUNK_SIZE;
        blob = index < NUM_CHUNKS ? file.file.slice(start, end) : file.file.slice(start);
        const uploadPart = { ...file };
        uploadPart.file = blob;
        uploadPart.url = urls[index - 1];
        uploadParts.push(uploadPart);

        // const res = yield call(api.uploadFile, uploadPart, uploadPart.url, data => {});
        // etags.push({ ETag: res.headers['etag'], PartNumber: index });
      }

      const responses = yield all(
        uploadParts.map(part =>
          call(api.uploadFile, part, part.url, data => {
            uploadFileCallback(data, part);
          }),
        ),
      );

      responses.forEach((res, index) => {
        etags.push({ ETag: res.headers['etag'], PartNumber: index + 1 });
      });

      const keyPath = new URL(urls[0]).pathname.slice(1);
      const completeUploadBody = {
        uploadId,
        path: keyPath,
        parts: etags,
      };

      yield call(api.completeMultiPartUpload, completeUploadBody);

      // yield call(api.uploadFile, file, uploadUrl, data => {
      //   uploadFileCallback(data, file);
      // });

      yield call(preUpload, file);
      yield put(successUploadFile(file.id));
    } else {
      yield put(failureUploadFile({ id: file.id, error: getUploadErrorMessage(response.data) }));
    }
  } catch (err) {
    const errorMessage = err?.message || 'File is failed to upload';
    yield put(failureUploadFile({ id: file.id, error: errorMessage }));
  }
}

function* uploadFileCallback(data, file) {
  yield put(setUploadProgress({ id: data.id, progress: data.progress }));
}

function* getExhibitUploadUrl(api, action) {
  yield call(APIHandler, api, action);
}

function* preExhibitUpload(api, action) {
  yield call(APIHandler, api, action);
}
function* downloadFiles(api, action) {
  try {
    yield all(action.files.map(file => call(prepareDownload, api, file)));
  } catch (error) {
    console.log('DOWNLOAD_FILES_SAGA', error);
  }
}

function* prepareDownload(api, file) {
  try {
    yield call(api.prepareDownload, file);
  } catch (err) {
    console.log('DOWNLOAD_FILE_SAGA', err);
    Toastify.success('Files has been downloaded failures!');
  }
}

function* getFinalUploadUrl(api, action) {
  yield call(APIHandler, api, action);
}

function* preFinalUpload(api, action) {
  yield call(APIHandler, api, action);
}

function* getProductionUploadUrl(api, action) {
  yield call(APIHandler, api, action);
}

function* preProductionUpload(api, action) {
  yield call(APIHandler, api, action);
}

export default {
  uploadFiles,
  getExhibitUploadUrl,
  preExhibitUpload,
  uploadSingleFile,
  downloadFiles,
  prepareDownload,
  preFinalUpload,
  getFinalUploadUrl,
  preProductionUpload,
  getProductionUploadUrl,
};
